import { render, staticRenderFns } from "./SharedLinkManageDialogBox.vue?vue&type=template&id=22df1a3c&scoped=true&"
import script from "./SharedLinkManageDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkManageDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df1a3c",
  null
  
)

export default component.exports